import { makeStyles } from "@material-ui/core";

export default makeStyles((theme) => ({
    title: {
        fontSize: 24,
        fontWeight: 550,
        padding: "1em 0"
    }
}));
